import { render, staticRenderFns } from "./CoachsFilters.vue?vue&type=template&id=6f39f3e5"
import script from "./CoachsFilters.vue?vue&type=script&lang=js"
export * from "./CoachsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports